import { WebStorageStateStore } from 'oidc-client-ts';

// Authorization Code + PKCE against Keycloak (react-oidc-context /
// oidc-client-ts). The credential form itself lives on Keycloak's hosted
// login page — signinRedirect() sends the browser there and back.
const oidcConfig = {
  authority: `${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}`,
  client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  redirect_uri: `${window.location.origin}/login`,
  post_logout_redirect_uri: `${window.location.origin}/login`,
  // Default userStore is sessionStorage, which is isolated per tab — a new
  // tab would find no session and force re-auth even though other tabs are
  // still logged in. localStorage is shared across tabs, same as the token
  // mirror in loginReducer.
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // oidc-client-ts defaults this to true and, since Keycloak issues a
  // refresh_token alongside the access token, uses it to renew silently
  // (no iframe) shortly before expiry. Set explicitly so it's not a hidden
  // library default — App.js's addSilentRenewError handler is what covers
  // the case where the refresh_token itself is no longer valid.
  automaticSilentRenew: true,
  onSigninCallback: () => {
    // Strip the ?code=&state= query params Keycloak appended on redirect.
    window.history.replaceState({}, document.title, window.location.pathname);
  }
};

export default oidcConfig;
